<template>
  <div class="the-header">
    <router-link to="/" class="the-header__logo">
      <img src="@/assets/nickjr.png" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
};
</script>

<style lang="scss">
.the-header {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 60px;

  background-color: #ffffff;

  img {
    height: 30px;
    width: auto;
  }
}
</style>
